export default function Settings() {
    return <h2 className="text-xl">Configuracion</h2>;
}
  